"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgTicket = function SvgTicket(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M330 665.6h364c12.6 0 22.7-11.5 22.7-25.6s-10.1-25.6-22.7-25.6H330c-12.6 0-22.8 11.5-22.8 25.6s10.2 25.6 22.8 25.6zM430.1 563.2h163.8c11.3 0 20.5-11.5 20.5-25.6 0-14.1-9.2-25.6-20.5-25.6H430.1c-11.3 0-20.5 11.5-20.5 25.6 0 14.2 9.2 25.6 20.5 25.6z"
  }), _react.default.createElement("path", {
    d: "M732.5 0h-81.2l-3.9 22.5C636.2 87.6 579.2 134.8 512 134.8c-67.3 0-124.2-47.2-135.5-112.3L372.7 0h-81.2c-76 0-137.9 60.5-137.9 134.8v754.4c0 74.3 61.8 134.8 137.9 134.8h81.2l3.8-22.4c11.3-65.1 68.2-112.3 135.5-112.3 67.2 0 124.2 47.2 135.4 112.3l3.9 22.4h81.2c76 0 137.9-60.4 137.9-134.8V134.8C870.4 60.5 808.6 0 732.5 0zm82.8 886.6c0 44.6-37.1 80.8-82.7 80.8h-36c-23.9-79.3-98.2-134.7-184.5-134.7s-160.6 55.4-184.5 134.7h-36c-45.6 0-82.7-36.2-82.7-80.8V358.4h606.5v528.2zm0-582.1H208.7V132.1c0-44.6 37.1-80.9 82.7-80.9h36C351.4 130.5 425.7 186 512 186s160.6-55.4 184.5-134.8h36c45.6 0 82.7 36.3 82.7 80.9v172.4z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgTicket, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;